module.exports = __webpack_public_path__ + "img/radio_off_dark.3a9bf5f7.svg";